import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DonneesBaseService } from '../services/donnees-base-service';
import { MessageInformationService } from '../services/message-information.service';
import {
    MessageInformationEntite,
    MessageInformationModalCloseResult,
} from '../entites/message-information';

export interface MessageInformationModalData {
    message: MessageInformationEntite;
    nePlusAfficherDefault: boolean;
}

@Component({
    templateUrl: './message-information-modal.component.html',
    styleUrls: ['./message-information-modal.component.scss'],
})
export class MessageInformationModalComponent implements OnInit {
    message: MessageInformationEntite;
    nePlusAfficher = false;

    readonly quillViewStyle: Record<string, string> = {
        'max-height': '50vh',
        overflow: 'hidden',
        'overflow-y': 'auto',
    };

    constructor(
        public sdb: DonneesBaseService,
        private ref: DynamicDialogRef,
        private config: DynamicDialogConfig<MessageInformationModalData>,
        private messageInformationService: MessageInformationService
    ) {}

    ngOnInit(): void {
        this.message = this.config.data.message;
        this.nePlusAfficher = this.config.data.nePlusAfficherDefault;
    }

    dateCreationFormatee(): string {
        if (!this.message?.dateCreation) {
            return '';
        }
        const date = new Date(this.message.dateCreation);
        return isNaN(date.getTime()) ? '' : date.toLocaleDateString('fr-CA', { dateStyle: 'long' });
    }

    onNePlusAfficherChange(checked: boolean): void {
        this.nePlusAfficher = checked;
        this.messageInformationService.enregistrerPreferenceNePlusAfficher(checked);
    }

    fermer(): void {
        const dismiss =
            !this.message.indDismissable || this.nePlusAfficher;
        const result: MessageInformationModalCloseResult = { dismiss };
        this.ref.close(result);
    }
}
